import { render, staticRenderFns } from "./LockReset.vue?vue&type=template&id=3477fab3"
import script from "./LockReset.vue?vue&type=script&lang=js"
export * from "./LockReset.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports